<template>
  <div class="starting-page">
    <div class="logo">
      <img src="~@/assets/images/Main_Black.svg" alt />
    </div>
    <router-view />

    <div class="account-disclaimer" v-if="canShowSignUp">
      <a href="/" @click.prevent.stop="$router.push('/auth/signup')">{{
        $t('AUTH_COMMON_SIGN_UP')
      }}</a>
    </div>
    <div class="starting-footer">
      <a href>Popsters Inc. © {{ currentYear }}</a>
      <a :href="'mailto:' + supportEmail">{{ $t('USR_CONT') }}</a>
      <a :href="docsPrivacy" target="_blank">{{ $t('USR_PRVC') }}</a>
      <a :href="docsTerms" target="_blank">{{ $t('USR_TERMS') }}</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Auth",
  computed: {
    canShowSignUp() {
      if (this.$route.path == "/auth/signup") return false;
      return true;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL;
    },
    docsPrivacy() {
      return process.env.VUE_APP_DOCS_PRIVACY;
    },
    docsTerms() {
      return process.env.VUE_APP_DOCS_TERMS;
    },
  },
};
</script>
